<template>
    <div>
        <div class="card-group">
            <div class="card" v-for="(quizField, index) in quizFields" v-bind:key="index">
                <p class="title">
                    <span v-if="quizField.PerguntaEmpresa.Obrigatorio == 1">*</span
                    >{{ quizField.Pergunta.Descricao }}
                </p>
                <div class="type">
                    <button
                        variant="light"
                        class="button-quiz Sim"
                        @click="
                            setAnswer('Sim', quizField.Pergunta.Id, true, false, true)
                        "
                        :class="'_' + quizField.Pergunta.Id"
                    >
                        <img src="@/assets/quizIcons/ic_like_grey.png" />
                    </button>
                    <button
                        variant="light"
                        class="button-quiz Nao"
                        @click="
                            setAnswer('Nao', quizField.Pergunta.Id, true, false, true)
                        "
                        :class="'_' + quizField.Pergunta.Id"
                    >
                        <img src="@/assets/quizIcons/ic_dislike_grey.png" />
                    </button>
                    <button
                        variant="light"
                        class="button-quiz Avariado"
                        @click="
                            setAnswer('Avariado', quizField.Pergunta.Id, true, true, true)
                        "
                        :class="'_' + quizField.Pergunta.Id"
                    >
                        <img src="@/assets/quizIcons/ic_taca_quebrada.png" />
                    </button>
                    <button
                        variant="light"
                        class="button-quiz N/A"
                        @click="
                            setAnswer('N/A', quizField.Pergunta.Id, true, false, true)
                        "
                        :class="'_' + quizField.Pergunta.Id"
                    >
                        <img src="@/assets/quizIcons/ic_na.png" />
                    </button>
                </div>
            </div>
        </div>
        <div class="container-buttons">
            <b-button @click="nextStage" class="mt-3 buttons" variant="success"
                >Próximo</b-button
            >
        </div>
    </div>
</template>

<script>
import SaveStage from "@/controller/saveStage";
import { BButton } from "bootstrap-vue";
import Swal from "sweetalert2";
export default {
    components: {
        BButton,
    },
    data: function () {
        return {
            quizFields: null,
            selected: undefined,
        };
    },
    methods: {
        async setAnswer(nameButton, id, saveAnswer, takePhotoItem, requestAvaria) {
            let avaria = "";
            let nameField;
            let avariasDaPergunta;

            const enterpriseConfig = JSON.parse(localStorage.getItem("enterpriseConfig"));
            const operationParams = this.$store.state.inspectionData.operation.parametros;
            const quizData = this.$store.state.inspectionData.quiz;

            for (let i = 0; i < quizData.length; i++) {
                const element = quizData[i];
                if (element.Pergunta.Id == id) {
                    nameField = element.Pergunta.Descricao;
                    avariasDaPergunta = element.Pergunta.Avarias;
                }
            }

            const selectedButton = document.getElementsByClassName(
                `_${id} ${nameButton}`
            )[0];
            const itemButtons = document.getElementsByClassName(`_${id}`);

            for (let i = 0; i < itemButtons.length; i++) {
                const button = itemButtons[i];
                button.style.backgroundColor = null;
            }
            switch (nameButton) {
            case "Sim":
                selectedButton.style.backgroundColor = "rgb(29, 202, 29)";
                break;
            case "Nao":
                selectedButton.style.backgroundColor = "red";
                break;
            case "Avariado": {
                selectedButton.style.backgroundColor = "yellow";
                if (enterpriseConfig.utiliza_tipo_avarias) {
                    let obrigaInformeAvaria = operationParams?.obriga_informe_tipo_avaria.ativo ?? false;

                    const utilizaAvarias =
                            (enterpriseConfig.utiliza_tipo_avarias.valor = 1);
                    if (
                        utilizaAvarias &&
                            avariasDaPergunta.length > 0 &&
                            requestAvaria
                    ) {
                        var options = {};
                        avariasDaPergunta.map((avaria) => {
                            options[avaria.id_avaria] = avaria.descricao;
                        });
                        const { value: idAvaria } = await Swal.fire({
                            title: "Selecione o tipo de avaria:",
                            icon: "question",
                            input: "select",
                            confirmButtonText: "Confirmar",
                            inputOptions: options,
                            inputPlaceholder: "Selecione uma avaria",
                            allowOutsideClick: false,
                            inputValidator: (value) => {
                                if (obrigaInformeAvaria)
                                    return (
                                        !value &&
                                            "Você precisa selecionar uma avaria!"
                                    );
                            },
                        });

                        if (idAvaria) {
                            var objAvaria = avariasDaPergunta.find(
                                (a) => a.id_avaria == idAvaria
                            );
                            avaria = `A;${idAvaria};${objAvaria.descricao};${objAvaria.referencia}`;
                        }
                    }
                }
                const takePhotoIfItemAvariado = operationParams?.tirar_fotos_questionario.ativo ?? false;

                if (takePhotoItem && takePhotoIfItemAvariado) {
                    await Swal.fire({
                        title: `Deseja tirar uma foto do item ${
                            objAvaria ? objAvaria.descricao : nameField
                        }?`,
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            const photo = {
                                ordem: 1,
                                photoName:
                                        objAvaria && objAvaria.descricao
                                            ? `AVARIA_${objAvaria.descricao}`
                                            : `AVARIA_${nameField}`,
                            };

                            this.$router.push({
                                name: "camera",
                                params: { photoData: photo }
                            });
                        }
                    });
                }
                break;
            }
            case "N/A":
                selectedButton.style.backgroundColor = "#038cfc";
                break;
            default:
                break;
            }
            if (saveAnswer) {
                this.saveQuizField(nameButton, nameField, avaria);
            }
        },
        
        saveQuiz: function () {
            const saveStage = new SaveStage();
            saveStage.quiz(this);
        },
        saveQuizField: function (buttonSelected, nameField, avaria) {
            this.$store.commit("setQuizFieldValue", {
                buttonSelected,
                nameField,
                avaria,
            });
        },
        nextStage: function () {
            this.$router.push("/inspection/photos-grid");
        },
        compareQuizFieldsOrder(fieldA, fieldB) {
            // Tentar primeiro ordenar pela propriedade 'PerguntaEmpresa.Ordem'
            const ordemA = fieldA.PerguntaEmpresa.Ordem;
            const ordemB = fieldB.PerguntaEmpresa.Ordem;
            if (ordemA < ordemB || (ordemA && !ordemB)) {
                // A vem primeiro na lista se a ordem for menor que a de B
                // OU se A tiver ordem e B não
                return -1;
            } else if (ordemA > ordemB || (!ordemA && ordemB)) {
                // A vem depois se a ordem for maior que B
                // OU se A não tiver ordem e B tiver
                return 1;
            } else {
                // Se a ordem for igual, comparar o ID
                const idA = fieldA.Pergunta.Id;
                const idB = fieldB.Pergunta.Id;
                if(idA < idB) {
                    return -1;
                } else if (idA > idB) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }
    },
    created: function () {
        window.scroll(0, 0);
        try {
            this.quizFields = this.$store.state.inspectionData.quiz.sort(this.compareQuizFieldsOrder);
        } catch (error) {
            this.quizFields = this.$store.state.inspectionData.quiz;
        }
    },
    mounted: function () {
        const quizData = this.$store.state.inspectionData.quiz;
        for (let i = 0; i < quizData.length; i++) {
            const id = quizData[i].Pergunta.Id;
            let standardAnswer = quizData[i].PerguntaEmpresa.RespostaPadrao;
            const answer = quizData[i].Resposta;
            if (answer) {
                this.setAnswer(answer, id, false, false, false);
            } else if (standardAnswer) {
                if (standardAnswer == "Não") {
                    standardAnswer = "Nao";
                }
                this.setAnswer(standardAnswer, id, true, false, true);
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        let showIncompleteAlert = true;
        if(to.name === "camera" || to.path.split("/")[1] !== "inspection"){
            showIncompleteAlert = false;
        }
        const saveStage = new SaveStage();
        saveStage.quiz(showIncompleteAlert);
        next();
    },
};
</script>

<style scoped>
.type {
    padding-left: 5vw;
    padding-right: 5vw;
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
}

.container-buttons {
    background: linear-gradient(#cdd7d6, white);
    width: 100%;
    position: fixed;
    bottom: 0;
    padding-left: 7%;
    padding-right: 7%;
    padding-bottom: 10px;
    right: 0;
}

.card {
    margin: 8px;
}

.card-group {
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
}

.buttons {
    float: right;
    width: 100px;
}

.button-quiz {
    margin: 2px;
    background-color: #f0f0f0;
    border: 1px solid #cacaca;
    border-radius: 5px;
    width: 15vw;
    height: 12vw;
}

.title {
    margin: 8px;
    margin-left: 6vw;
    margin-top: 10px;
    font-size: 15px;
}

.highlightG {
    background-color: rgb(29, 202, 29);
}

.highlightR {
    background-color: red;
}

.highlightY {
    background-color: yellow;
}

.highlightB {
    background-color: #038cfc;
}
</style>
